/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Forbidden,
  InstallationSmartHomeResponse,
  NotFound,
  Unauthorized,
} from '../models';

export interface CrmInstallationsSmartHomeGetSmartHomeInstallationsRequest {
    id: string;
}

/**
 * 
 */
export class CRMInstallationsSmartHomeApi extends runtime.BaseAPI {

    /**
     * Retrieves all smart home device installations for a customer. Returns home automation configurations including connected IoT devices, integration platforms (e.g., Home Assistant, SmartThings), device status, and automation rules
     * Get All Smart Home Installations
     */
    async crmInstallationsSmartHomeGetSmartHomeInstallationsRaw(requestParameters: CrmInstallationsSmartHomeGetSmartHomeInstallationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallationSmartHomeResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsSmartHomeGetSmartHomeInstallations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/smarthome`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all smart home device installations for a customer. Returns home automation configurations including connected IoT devices, integration platforms (e.g., Home Assistant, SmartThings), device status, and automation rules
     * Get All Smart Home Installations
     */
    async crmInstallationsSmartHomeGetSmartHomeInstallations(requestParameters: CrmInstallationsSmartHomeGetSmartHomeInstallationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallationSmartHomeResponse> {
        const response = await this.crmInstallationsSmartHomeGetSmartHomeInstallationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
